define('wazoom', ['jquery'], function ($) {

  var wazoom = {
    init: function init() {
      //if (!window.isTouchDevice) this.noTouchDeviceInit();
    },
    noTouchDeviceInit: function noTouchDeviceInit() {

      $('.js_zoomimg').wrap('<div/>').parent().zoom();
    },
    photoswipe: function photoswipe(el) {
      var pswpElement = $('.pswp')[0];
      var slideImg = $('.js_productSlider')[0];
      var sliderNav = $('.js_productSliderNav');
      var pinchIcon = $('.pswp__pinch--icon');
      var elIndex = Number(el.getAttribute('data-image'));

      if (pswpElement.length == 0) return;

      var index = elIndex;
      var items = [];

      var options = {
        index: index,
        bgOpacity: 1,
        showHideOpacity: 0,
        shareEl: 0,
        clickToCloseNonZoomable: 1,
        fullscreenEl: 1,
        preloaderEl: 1,
        zoomEl: 1,
        modal: 1,
        closeOnScroll: 0,
        captionEl: 0,
        loop: 1,
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = slideImg.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };

      var item = $('.js_productSlider .owl-item:not(.cloned) .js_touchzoom[onclick]');
      var toPswp = {};

      if (item.length == 0) {
        item = $('.js_productSlider .js_touchzoom');
      }

      item.each(function (i, val) {
        if (!$(this).hasClass('video')) {
          toPswp = {
            src: $(this).find('img').attr('data-src') || $(this).find('img').attr('src'),
            w: 1080,
            h: 1080
          };
        }
        items.push(toPswp);
      });

      var pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      pswp.init();

      pswp.listen('afterChange', function () {
        var itemIndex = $('.js_productSlider .owl-item:not(.cloned) .js_touchzoom[data-image="' + pswp.getCurrentIndex() + '"]').data('index');
        $('.js_productSlider').trigger('to.owl.carousel', [itemIndex, 0, true]);
      });

      if (!!window.isTouchDevice) {
        pinchIcon.hide().delay(1000).fadeIn(500).delay(1000).fadeOut(500);
      }
    }
  };

  window.photoswipe = wazoom.photoswipe;

  return wazoom;
});

